const blueprintStringPropertyNames = [
    'answerNodeId',
    'repeatableAnswerNodeId',
    'nodeId',
    'targetNodeId',
    'at',
    'product',
    'coverageAmount',
    'useNeedsAnalysisNodeId',
    'fromCollection',
    'repeatableCollectionNodeId',
];
const blueprintArrayPropertyNames = ['firstNonEmptyValueAt'];
// Orphan node-ids are node ids that are not assigned to a field in the blueprint.
// Meaning node-ids that are not used for a fieldGroup's answer.
// Mostly use because of hacks like products etc...
// In theory they should not exist in the dream system.
export const generateOrphanNodeIdsFromBlueprint = (blueprint) => {
    const allNodeIds = new Set(searchJSONForNodeId(blueprint));
    const nodeIdsUsedInBlueprint = findNodeIdsAssignedInBlueprint(blueprint);
    const setOrphanNodeIds = new Set([]);
    for (const nodeId of allNodeIds) {
        if (nodeIdsUsedInBlueprint.has(nodeId) === false) {
            setOrphanNodeIds.add(nodeId);
        }
    }
    return setOrphanNodeIds;
};
function searchJSONForNodeId(currentScope) {
    const nodeIdsInChildren = Object.keys(currentScope).map((property) => {
        const propertyValue = currentScope[property];
        if (typeof propertyValue !== 'object') {
            // The thing is not an array nor an object.
            return [];
        }
        // Handling array property
        if (propertyValue.length) {
            return propertyValue.map((e) => searchJSONForNodeId(e)).flat();
        }
        // Handling object property
        return searchJSONForNodeId(propertyValue);
    });
    // Handling nodeIdOnCurrentScope
    const currentScopeNodeIds = [];
    for (const name of blueprintStringPropertyNames) {
        const propertyValue = currentScope[name];
        if (propertyValue && typeof propertyValue === 'string') {
            currentScopeNodeIds.push(propertyValue);
        }
    }
    for (const name of blueprintArrayPropertyNames) {
        const propertyValues = currentScope[name];
        if (propertyValues && typeof propertyValues.length) {
            for (const item of propertyValues) {
                currentScopeNodeIds.push(item);
            }
        }
    }
    return currentScopeNodeIds.concat(nodeIdsInChildren.flat());
}
function findNodeIdsAssignedInBlueprint(blueprint) {
    const fieldOrRepeatableParentNodeIds = new Set();
    Object.values(blueprint.sectionGroupBlueprints).forEach((sectionGroup) => {
        if (sectionGroup.repeatable?.repeatableAnswerNodeId) {
            fieldOrRepeatableParentNodeIds.add(sectionGroup.repeatable.repeatableAnswerNodeId);
        }
    });
    for (const section of blueprint.sectionBlueprints) {
        for (const subsection of section.subsections) {
            for (const fieldGroup of subsection.fieldGroups) {
                if (fieldGroup.repeatable?.repeatableAnswerNodeId) {
                    fieldOrRepeatableParentNodeIds.add(fieldGroup.repeatable.repeatableAnswerNodeId);
                }
                for (const field of fieldGroup.fields) {
                    if (field.answerNodeId) {
                        fieldOrRepeatableParentNodeIds.add(field.answerNodeId);
                    }
                }
            }
        }
    }
    return fieldOrRepeatableParentNodeIds;
}
